export const TAB_NAMES: Record<number, string> = { 0: 'compra', 1: 'venda' };

/** Nome de tab usado como fallback (tab "Comprando", índice 0). */
export const DEFAULT_TAB_NAME = TAB_NAMES[0];
